<template>
  <div :class="defaultclass" role="alert" v-if="error">
    <table class="w100">
      <tr>
        <td v-if="messageKey">
          {{$t(messageKey)}}
          <!--<template v-if="fncb">({{dataObject[dataKey]}})</template>-->
        </td>
        <td v-if="!messageKey">
          {{$t('DataCheckerErrorDisplayer.message')}}
          <!--<template v-if="fncb">({{dataObject[dataKey]}})</template>-->
        </td>
        <!--<td class="w1" v-if="fncb">-->
        <!--<button type="button" id="navGetDetails" class="btn btn-primary btn-sm" v-on:click="callCb">-->
        <!--<i class="fa fa-dot-circle-o"></i> {{$t('global.copy')}}-->
        <!--</button>-->
        <!--</td>-->
      </tr>
    </table>

  </div>
</template>
<script>

  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import SettingsContainer from '@/helper/SettingsContainer';

  export default {
    name: 'DataCheckerErrorDisplayer',
    mounted() {
      console.log("DataCheckerErrorDisplayer");
      const modul = this;
      modul.init();
//      modul.$eventBus.$on('globalSetBusinessPartner', this.globalSetBusinessPartnerEventHandler);
    },
    beforeDestroy() {
//      this.$eventBus.$off('globalSetBusinessPartner');
    },
    data() {
      return {
        dataObject: {},
        error: false,
      }
    },
    watch: {
//      dataObjectStr: function (newValue, oldValue) {
//        const modul = this;
//        try {
//          modul.dataObject = JSON.parse(newValue);
//          modul.work();
//        } catch (e) {
//        }
//      },
//      dataKey: function (newValue, oldValue) {
//        const modul = this;
//        modul.work();
//      },
      value: function (newValue, oldValue) {
        const modul = this;
        modul.work(newValue);
      },
      defaultclass: function (newValue, oldValue) {
        const modul = this;
        modul.work(modul.value);
      },

    },

    props: {
      dataKey: {
        type: String,
        default: ''
      },
      value: { // data
        type: [String, Number],
        default: ''
      },
//      dataObjectStr: { // nav object
//        type: String,
//        default: ""
//      },
      defaultclass: {
        type: String,
        default: 'alert alert-danger'
      },
//      irrelevantCapitalized: {
//        type: String,
//        default: 'false'
//      },
      messageKey: {
        type: String,
        default: ''
      },
      isMandatory: {
        type: Boolean,
        default: false
      },
      fncb: {
        type: Function,
        default: function (event) {
        }
      },
      displayfn: {
        type: Function,
        default: function (event) {
        }
      },
    },
    methods: {
      init(){
        const modul = this;
        try {
//          modul.dataObject = JSON.parse(modul.dataObjectStr);
          modul.work();
        } catch (e) {
          modul.work();
        }
      },
      callCb(){
        const modul = this;
        if (typeof modul.fncb === "function") {
          modul.fncb(modul.dataKey);
        }
      },
      work(){
        const modul = this;
        const value = (modul.value === null ) ? "" : modul.value;
        if (modul.isMandatory && value.length === 0) {
          modul.error = true;
        } else if (!modul.isMandatory && value.length === 0) {
          modul.error = false;
        } else if (!modul.isMandatory && value.length > 0) {
          const isDisplay = modul.displayfn(value);
          modul.error = !isDisplay
        }
      },
    },
    components: {},
  };
</script>
